(function ($) {

    let last_ajax_request;
    function updateReturnSummary() {
        let $form = $(this).closest('form');

        let url = $form.attr('action') + "&action=return_registration_summary",
            data = $form.serializeArray()

        // remove action to prevent collision in ajax
        data = data.filter((item) => item.name !== 'action');

        if(last_ajax_request){
            last_ajax_request.abort();
        }

        last_ajax_request = gp_ajax({
            url: url,
            type: "post",
            dataType: "json",
            show_loading: false,
            data: data
        });
    }

    $('form[data-form-id="return-registration"]')
        .on('change', 'input[name$="[return]"]', updateReturnSummary);


    $('[data-return-quantity-action]').on('click', function () {
        let action = $(this).data('return-quantity-action'),
            $input = $(this).siblings('input[type="number"]'),
            current_qty = parseInt($input.val());

        if (action === 'plus') {
            let max = $input.attr("max") ? parseInt($input.attr("max")) : 0;
            if (!max || current_qty < max) {
                $input.val(current_qty + 1).trigger('change');
            }
        } else if (action === 'minus') {
            let min = $input.attr("min") ? parseInt($input.attr("min")) : 1;
            if (current_qty > min) {
                $input.val(current_qty - 1).trigger('change');
            }
        }
    });

    // we have multiple inputs with the same name, so we need to update all of them
    $('.order-return-item input[type="number"]').on('change', function () {
        let $this = $(this);
        $this.closest('.order-return-item').find('input[name="' + $this.attr('name') + '"]').not($this).val($this.val());

        updateReturnSummary.call(this);
    });

    //checkbox item trigger
    $('span.order-return-item__link[data-form-id="return-registration"]').on('click', function (e) {
        e.preventDefault();
        let $checkbox = $(this).closest('.order-return-item').find('input[name$="[return]"]');
        $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
        updateReturnSummary.call(this);
    }).on('mouseenter', function () {
        let $checkbox = $(this).closest('.order-return-item').find('input[name$="[return]"]');
        $checkbox.closest('.checkbox').addClass('-is-hovered');
    }).on('mouseleave', function () {
        let $checkbox = $(this).closest('.order-return-item').find('input[name$="[return]"]');
        $checkbox.closest('.checkbox').removeClass('-is-hovered');
    });

})(jQuery);
